import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import RankingSection from "./components/RankingSection";
import LatestSection from "./components/LatestSection";
import TopicsSection from "./components/TopicsSection";
import TrustBand from "./components/TrustBand";
import { usePageMeta } from "@/hooks/usePageMeta";
import { gossipItems } from "@/mocks/gossip";

export default function Home() {
  const topItems = [...gossipItems].sort((a, b) => b.views - a.views).slice(0, 8);

  usePageMeta({
    title: "视频吃瓜 | 视频吃瓜第一现场 · 实拍完整版录像路透一网打尽",
    description:
      "视频吃瓜聚合站，收录视频吃瓜实拍、第一现场、完整版、录像、路透与分直拍。热度排行每小时更新，点开即可直击现场实拍与路透片段，满足你对第一现场的好奇心。",
    keywords: "视频吃瓜,视频吃瓜实拍,视频吃瓜第一现场,视频吃瓜完整版,视频吃瓜录像,视频吃瓜路透,视频吃瓜分直拍",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "瓜田影像社",
        alternateName: "视频吃瓜第一现场",
        url: "https://guatian-live.example.com/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://guatian-live.example.com/?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "瓜田影像社",
        url: "https://guatian-live.example.com/",
        email: "contact@guatian-live.example.com",
        description: "面向娱乐现场内容爱好者的视频吃瓜聚合站，收录实拍、第一现场、完整版、录像、路透与分直拍六类内容。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "视频吃瓜热度排行",
        itemListElement: topItems.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `https://guatian-live.example.com/video/${item.id}`,
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        <Hero />
        <CategoryStrip />
        <RankingSection />
        <LatestSection />
        <TopicsSection />
        <TrustBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}